import { useMutation } from '@tanstack/react-query'

import { activityFeedClient } from './feed.service'

export const useV2ShipmentEntityFeedActivityCreate = () => {
  return useMutation({
    mutationFn: activityFeedClient.createV2ShipmentFeedActivity,
  })
}
